<script setup lang="ts">
import { Enums } from "@/enums";
import { computed } from "vue";
import { assertUnhandledStatus } from "../../common/asserts.common";

const props = defineProps<{
    status: Enums.AssociateRegistrationStatusEnum.Values;
}>();

const label = computed(() => Enums.AssociateRegistrationStatusEnum.label(props.status));
const color = computed(() => {
    switch (props.status) {
        case "W":
            return "bg-gray-500";
        case "A":
            return "bg-green-500";
        case "R":
            return "bg-red-500";
        default:
            return assertUnhandledStatus(props.status);
    }
});
</script>

<template>
    <div class="rns-g-badge" :class="color">{{ label }}</div>
</template>

<style>
@reference "@/styles/main.css";
</style>
